import { render, staticRenderFns } from "./VehicleSwiper.vue?vue&type=template&id=39ef74ce&scoped=true&"
import script from "./VehicleSwiper.vue?vue&type=script&lang=js&"
export * from "./VehicleSwiper.vue?vue&type=script&lang=js&"
import style0 from "./VehicleSwiper.vue?vue&type=style&index=0&id=39ef74ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ef74ce",
  null
  
)

export default component.exports